import { useApolloClient } from '@apollo/client'
import React, {
  useEffect,
  useState,
  useMemo,
  ReactNode,
  useContext,
} from 'react'
import * as auth from '../../authentication/authentication'

export type AuthContextValue = {
  isInitialized: boolean
  isLoggedIn: boolean
  login: () => Promise<void>
}

export const AuthenticationContext = React.createContext<AuthContextValue>({
  isInitialized: false,
  isLoggedIn: false,
  login: async () => {},
})

type Props = {
  children: ReactNode
}

export function AuthenticationProvider({
  children,
}: Props): React.ReactElement {
  const [isInitialized, setIsInitialized] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const client = useApolloClient()

  useEffect(() => {
    const init = async () => {
      setIsLoggedIn(await auth.isLoggedIn())
      setIsInitialized(true)
    }

    void init()
  }, [])

  const authContext = useMemo(
    (): AuthContextValue => ({
      isInitialized,
      isLoggedIn,

      login: async () => {
        await auth.login()
        await client.resetStore()
        setIsLoggedIn(await auth.isLoggedIn())
      },
    }),
    [client, isInitialized, isLoggedIn],
  )

  return (
    <AuthenticationContext.Provider value={authContext}>
      {children}
    </AuthenticationContext.Provider>
  )
}

export const useAuthentication = (): AuthContextValue =>
  useContext(AuthenticationContext)
